import { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import BlogHeader from './BlogHeader'
import Posts from './Posts'

function App({ data, endpoint }) {
  const initialLoad = useRef(true)
  const [items, setItems] = useState(data.items)
  const [isLoading, setIsLoading] = useState(false)
  const [resultsHasMore, setResultsHasMore] = useState(data.results_has_more)
  const [resultsOffset, setResultsOffset] = useState(data.results_offset)
  const [resultsTotal, setResultsTotal] = useState(data.results_total)
  const [filters, setFilters] = useState(data.filters)

  const handleLoadMore = () => {
    const url = new URL(`${endpoint}more?${data.url_params}`)
    url.searchParams.append('offset', resultsOffset)

    for (const [key, value] of Object.entries(filters)) {
      url.searchParams.append(key, value)
    }

    setIsLoading(true)

    ajax
      .url(url.href)
      .get()
      .json((res) => {
        if (res.success) {
          setResultsOffset(res.results_offset)
          setResultsHasMore(res.results_has_more)
          setItems([...items, ...res.items])
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleFilter = (name, value) => {
    setFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  useEffect(() => {
    if (initialLoad.current) {
      initialLoad.current = false
      return
    }

    const url = new URL(`${endpoint}fetch?${data.url_params}`)
    url.searchParams.append('offset', 0)

    for (const [key, value] of Object.entries(filters)) {
      url.searchParams.append(key, value)
    }

    setIsLoading(true)

    ajax
      .url(url.href)
      .get()
      .json((res) => {
        if (res.success) {
          setResultsOffset(res.results_offset)
          setResultsHasMore(res.results_has_more)
          setResultsTotal(res.results_total)
          setItems(res.items)
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [filters])

  const handleReset = () => {
    window.location.href = endpoint
  }

  return (
    <section className="relative py-4 md:py-8">
      <div className="container">
        <BlogHeader
          items={items}
          resultsTotal={resultsTotal}
          filters={filters}
          handleFilter={handleFilter}
          isFiltered={data.is_filtered}
          handleReset={handleReset}
        />

        <div className="relative">
          <Posts items={items} />

          {isLoading && (
            <div className="absolute inset-0 z-10 flex items-start justify-center pt-8 text-xl bg-white bg-opacity-80"></div>
          )}
        </div>

        {items.length === 0 ? (
          <div className="mt-8 text-center">
            <div className="text-2xl font-medium">No posts found.</div>
            <button type="button" className="mt-8 btn btn-fill" onClick={handleReset}>
              Try Another Search
            </button>
          </div>
        ) : (
          <div className="mt-8 md:mt-16">
            <div className="text-center text-gray-400">
              {items.length.toString().padStart(2, '0')} of {data.results_total.toString().padStart(2, '0')}
            </div>

            {resultsHasMore && (
              <div className="mt-8 text-center">
                <button type="button" className="bg-white btn btn-hollow" onClick={handleLoadMore}>
                  Load More
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  )
}

App.propTypes = {
  data: PropTypes.object,
  endpoint: PropTypes.string,
}

export default App
